import React, { useEffect, useState, useRef } from 'react';
import brandMain from '../../assets/images/brand/brand_main.png';

const BrandMain = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-gradient-to-b md:bg-gradient-to-r from-[#973BEE] to-[#E088EC] py-16 flex items-center justify-center py-[60px] md:pt-[120px] md:pb-[120px]">
      <div className="flex flex-col md:flex-row items-center md:items-center md:gap-[40px]">
        <div className="flex flex-col items-center md:items-start">
          <h2 className={`font-normal md:font-bold text-[20px] md:text-[48px] leading-[100%] text-white text-center md:text-left transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            신규 고객들과 연결되는 가장 빠른 방법
          </h2>
          <h2 className={`font-semibold md:font-bold text-[32px] md:text-[48px] leading-[140%] text-white text-center md:text-left mt-4 md:mt-4 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            <span className="md:hidden">
              컬러 렌즈 플랫폼,<br />폰피쉬에 합류하세요.
            </span>
            <span className="hidden md:inline">
              컬러 렌즈 플랫폼, 폰피쉬에 합류하세요.
            </span>
          </h2>
        </div>

        <img
          src={brandMain}
          alt="폰피쉬 브랜드 메인 이미지"
          className={`w-[160px] h-[160px] object-contain drop-shadow-lg mt-8 md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        />
      </div>
    </section>
  );
};

export default BrandMain; 